import React from 'react';
import { ArrowRight } from '../icons';
import { IMG } from '../data/constants';

const About = ({ t }) => (
  /* full-width bg */
  <div className="w-full bg-white ">
    {/* max-width 12-col grid */}
    <div className="max-w-[1440px] mx-auto px-[120px] h-[640px]  box-border grid grid-cols-12 gap-x-6 items-center">

      {/* Text — columns 1–5 */}
      <div className="col-span-5 flex flex-col gap-6 ">
        <h2 className="m-0 font-heading font-medium text-[50px] leading-[1.08] text-navy tracking-[-0.01em]">
          {t.aboutTitle}
        </h2>
        <p className="m-0 text-[18px] leading-[1.75] text-muted">
          {t.aboutBody}
        </p>
        <div className="pt-2">
          <a
            className="btn inline-flex items-center gap-3 h-12 px-[26px] rounded-[3px] border-[1.5px] border-navy text-navy text-[12.5px] font-bold tracking-widest uppercase"
            href="#"
          >
            {t.learnMore} <ArrowRight size={16} />
          </a>
        </div>
      </div>

      {/* Image — columns 7–12 */}
      <div className="col-start-7 col-span-6 flex flex-col gap-3">
        <div
          className="relative h-[448px] overflow-hidden rounded-[8px]"
          style={{ background: 'linear-gradient(135deg, #dbe8f0 0%, #b8d0e0 100%)' }}
        >
          <img src={IMG.about} alt="" className="absolute inset-0 w-full h-full object-cover block" />
        </div>
        <span className="text-[13px] text-muted">{t.aboutCaption}</span>
      </div>
    </div>
  </div>
);

export default About;
